import(/* webpackMode: "eager" */ "/vercel/path0/components/access-check.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/content-wrapper/content-left.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/content-wrapper/content-right.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThreeResearchers"] */ "/vercel/path0/components/four-researchers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/research-feed-l-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sale-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SaveButton"] */ "/vercel/path0/components/saved-pages.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/staff-edit-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/study-data-client.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/alert.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BreadCrumb","BreadCrumbItem"] */ "/vercel/path0/components/ui/bread-crumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Collapsible","CollapsibleTrigger","CollapsibleContent"] */ "/vercel/path0/components/ui/collapsible.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["fetchWrapper"] */ "/vercel/path0/lib/hooks/fetch-client.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
